export { stringToColor }

type HexString = `#${string}`

const stringToColor = (str: string): HexString => {
  /* eslint-disable no-magic-numbers */

  let hash = 0
  let color: HexString = '#'

  str.split('').forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash)
  })

  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    color += value.toString(16).padStart(2, '0')
  }

  /* eslint-enable no-magic-numbers */
  return color
}
